// extracted by mini-css-extract-plugin
module.exports = {"root":"AuditResults_root__2GAXn","spacer":"AuditResults_spacer__3T3GW"};